import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faGripVertical,
  faPlus,
  faTrash,
  faTurnDown,
} from '@fortawesome/free-solid-svg-icons';
import { InputAdornment, TextField, Typography } from '@mui/material';
import React, { useState } from 'react';
import { MdArrowBack } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import api, { authHeader } from '../../../../../../../services/API/apiConfig';
import { DialogBox } from '../../../../../../components/singleComponents/dialogs/DialogBox';
import ToasterBox from '../../../../../../components/singleComponents/toaster/ToasterBox';
import { EditingTable } from './EditBudgetV2/components/EditingTable/EditingTable';
import { useTableDataContext } from './EditBudgetV2/context/EditingTableDataContext';
import {
  ArrowBackStyled,
  DefaultButtonContainedStyled,
  DefaultButtonOutlinedStyled,
  MiddleOfThePageStyled,
  RootStyled,
  TitlesStyled,
} from './NewBudget.styles';

library.add(faGripVertical);
library.add(faPlus);
library.add(faTurnDown);
library.add(faTrash);

export function NewBudget() {
  const navigate = useNavigate();
  const { allTableDataWithExtraInfo, updateTableData } = useTableDataContext();

  const [squareMeters, setSquareMeters] = useState('');
  const constructionId = JSON.parse(localStorage.getItem('constructionId'));
  const [successMessage, setSuccessMessage] = useState('');
  const [successSubmit, setSuccessSubmit] = useState(false);
  const [errorSubmit, setErrorSubmit] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [openDialog, setOpenDialog] = useState(false);

  function handleGoBack() {
    localStorage.removeItem('constructionId');
    navigate(-1);
  }

  function handleCloseDialog() {
    setOpenDialog(!openDialog);
  }

  const handleFormSubmit = (event) => {
    event.preventDefault();

    setErrorSubmit(false);
    setErrorMessage('');

    const data = {
      budget: {
        square_meters: parseInt(squareMeters, 10),
        items_attributes: allTableDataWithExtraInfo.items_attributes,
      },
    };

    api
      .post(`/constructions/${constructionId}/budgets`, data, {
        headers: authHeader(),
      })
      .then((res) => {
        if (res.data.status === 0) {
          setSuccessMessage('Lançamento salvo com sucesso');
          setSuccessSubmit(true);
          localStorage.removeItem('constructionId');
          localStorage.removeItem('copyWithValues');
          setTimeout(() => {
            handleGoBack();
          }, 1500);
        } else {
          setSuccessMessage('Orçamento salvo com sucesso');
          setSuccessSubmit(true);
        }
      })
      .catch((error) => {
        setErrorMessage(error.response.data['items.description'][0]);
        setErrorSubmit(true);
      });
  };

  const updateSquareMetersHandler = (event) => {
    setSquareMeters(event.target.value);
  };

  const handleClearBudget = () => {
    updateTableData({
      items_attributes: [],
      construction: allTableDataWithExtraInfo.construction,
    });
  };

  return (
    <>
      <RootStyled>
        {successSubmit && <ToasterBox message={successMessage} />}
        {errorSubmit && <ToasterBox message={errorMessage} />}
        <dHeaderContainerStyled>
          <ArrowBackStyled
            onClick={() => setOpenDialog(!openDialog)}
            size="large"
          >
            <MdArrowBack size={42} color="#000" />
          </ArrowBackStyled>
          <TitlesStyled>
            <Typography variant="h1">Novo orçamento</Typography>
            <Typography variant="body1">
              {allTableDataWithExtraInfo.construction}
            </Typography>
          </TitlesStyled>
        </dHeaderContainerStyled>

        <MiddleOfThePageStyled>
          <TextField
            label="m² da obra"
            variant="outlined"
            slotProps={{
              inputLabel: { shrink: true },
            }}
            InputProps={{
              endAdornment: <InputAdornment position="end">m²</InputAdornment>,
            }}
            value={squareMeters}
            onChange={updateSquareMetersHandler}
          />
          <div>
            <DefaultButtonOutlinedStyled
              variant="outlined"
              color="primary"
              onClick={handleClearBudget}
            >
              Limpar orçamento
            </DefaultButtonOutlinedStyled>
            <DefaultButtonContainedStyled
              variant="contained"
              color="secondary"
              onClick={handleFormSubmit}
            >
              Salvar orçamento
            </DefaultButtonContainedStyled>
          </div>
        </MiddleOfThePageStyled>

        <EditingTable />
      </RootStyled>
      <DialogBox
        title="Cancelar criação de orçamento"
        content="Deseja realmente cancelar a criação? Todas as informações inseridas serão perdidas."
        openDialog={openDialog}
        closeDialog={() => handleCloseDialog()}
        mainAction={() => handleGoBack()}
      />
    </>
  );
}
